<template>
	<div class="async-error" @click="reload">
		<div class="async-error__icon">
			<div class="async-error__cloud"></div>
			<div class="async-error__slash"></div>
		</div>
		<div class="async-error__text">Network error</div>
		<div class="async-error__btn">Tap to retry</div>
	</div>
</template>

<script setup>
const reload = () => {
	if (typeof window !== 'undefined') {
		window.location.reload()
	}
}
</script>

<style lang="scss" scoped>
.async-error {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 60vh;
	padding: 40rpx;
	box-sizing: border-box;

	&__icon {
		position: relative;
		width: 200rpx;
		height: 200rpx;
		margin-bottom: 40rpx;
	}

	&__cloud {
		position: absolute;
		left: 50%;
		top: 50%;
		width: 140rpx;
		height: 90rpx;
		background: #d8d8d8;
		border-radius: 60rpx;
		transform: translate(-50%, -50%);

		&::before,
		&::after {
			content: '';
			position: absolute;
			background: #d8d8d8;
			border-radius: 50%;
		}

		&::before {
			width: 70rpx;
			height: 70rpx;
			left: 16rpx;
			top: -36rpx;
		}

		&::after {
			width: 50rpx;
			height: 50rpx;
			right: 20rpx;
			top: -28rpx;
		}
	}

	&__slash {
		position: absolute;
		left: 50%;
		top: 50%;
		width: 220rpx;
		height: 8rpx;
		background: #000;
		border-radius: 4rpx;
		transform: translate(-50%, -50%) rotate(-35deg);
		z-index: 2;
	}

	&__text {
		font-size: 28rpx;
		color: #999;
		margin-bottom: 32rpx;
	}

	&__btn {
		padding: 16rpx 48rpx;
		font-size: 28rpx;
		color: #fff;
		background: #000;
		border-radius: 40rpx;
	}
}
</style>
